import { BaseWebService } from "./base.web.service";
import { PendingTerms } from "../models/terms/pendingTerms";

export class TermsWebService extends BaseWebService {

    // Returns undefined on 204 (nothing pending).
    public async getPendingTerms(organizationId: string): Promise<PendingTerms | undefined> {
        const headers = await this.getHeadersJsonForOrganization(organizationId);
        const url = `${this.appConfig.serviceUserManagementUrl}/api/v1/terms/pending`;
        return this.makeRequest<PendingTerms | undefined>(url, 'GET', headers);
    }

    // No request body; the effective role is resolved from X-Organization-ID. Returns 204.
    public async acknowledgeTerms(organizationId: string): Promise<void> {
        const headers = await this.getHeadersJsonForOrganization(organizationId);
        const url = `${this.appConfig.serviceUserManagementUrl}/api/v1/terms/acknowledge`;
        await this.makeRequest<void>(url, 'POST', headers);
    }
}
